module.exports = __webpack_public_path__ + "static/media/S (24).89ab9e46.jpg";